export default {"src":"/_next/static/media/media.5f0697d8.svg","height":40,"width":40};